import React, {useEffect, useState} from 'react';
import { useCourt } from "../context/contextHooks";
import { useStyles } from '../styles/styles';
import useTheme from "@mui/material/styles/useTheme";
import useMediaQuery from "@mui/material/useMediaQuery";
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Grid from "@mui/material/Grid";
import {getCurrency, statesLong} from "../global/utils";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import FormLabel from '@mui/material/FormLabel';
import { PatternFormat } from "react-number-format";
import Link from '@mui/material/Link';
import Popup from '../layout/Popup';
import ShortTandC from "../layout/ShortTandC";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Select from "@mui/material/Select";
import { validateCheckData } from './paymentFunctions';

const CheckData = (props) => {
    const paymentRequest = props.paymentRequest;
    const paymentFields = props.paymentFields;
    const setPaymentFields = props.setPaymentFields;
    const setAcceptTerms = props.setAcceptTerms;
    const splitFees = props.splitFees;
    const [court,] = useCourt();
    const classes = useStyles;
    const theme = useTheme();
    const smallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const [openTandC, setOpenTandC] = useState(false);
    const [name, setName] = useState(paymentRequest.payorName);

    const handleName = (e) => {
        const val = e.target.value;
        if (val && val !== paymentRequest.payorName) {
            setPaymentFields({...paymentFields, payorName: val});
        }
    }

    const handleRoutingNumber = (values) => {
        if (values.value && values.value.length === 9) {
            setPaymentFields({...paymentFields, routingNumber: values.value});
        }
    }

    const handleAccountNumber = (e) => {
        const val = e.target.value;
        if (val && val.length > 3) {
            setPaymentFields({...paymentFields, bankAccountNumber: val});
        }
    }

    const handleZip = (values) => {
        if (values && values.value && values.value.length === 5) {
            const val = values.value;
            if (val !== paymentRequest.billingZip) {
                setPaymentFields({...paymentFields, billingZip: val});
            }
            paymentRequest.billingZip = val;
        }
    }

    const handleEmail = (e) => {
        const val = e.target.value;
        setPaymentFields({...paymentFields, email: val});
    }

    const handlePhone = (values) => {
        if (values?.value.length === 10) {
            const val = values.formattedValue;
            setPaymentFields({ ...paymentFields, phone: val });
        } else if (values.value === "") {
            setPaymentFields({ ...paymentFields, phone: null });
        }
    };

    const closeTandC = (close) => {
        if (close) {
            setOpenTandC(false);
        }
    }

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            setOpenTandC(true);
        }
    }

    const hasValidationErrors = () => {
        return validateCheckData(paymentFields, court) !== '';
    };

    useEffect(() => {
        setName(paymentRequest.payorName);
    }, [paymentRequest.payorName]);

    return (
        <>
            { openTandC &&
                <Popup open={openTandC} setDone={closeTandC} title="Terms and Conditions" component={<ShortTandC/>} />
            }
            <Paper variant='body1' elevation={3} sx={smallScreen ? {} : classes.controlPanel}>
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={6} sx={{paddingLeft: '0', paddingTop: smallScreen ? '0' : '1rem'}}>
                        { splitFees ?
                            <Grid container spacing={1}>
                                <Grid item xs={6} style={{padding: '0'}}>
                                    <Typography color='primary' sx={{fontSize: '.9rem', textAlign: 'right'}}>Item Subtotal:</Typography>
                                </Grid>
                                <Grid item xs={6} style={{padding: '0'}}>
                                    <Typography color='textPrimary' sx={{fontSize: '.9rem', textAlign: 'right', paddingRight: '2rem'}}>
                                        {getCurrency(paymentRequest.courtAmount)}
                                    </Typography>
                                </Grid>
                                <Grid item xs={6} style={{padding: '0'}}>
                                    <Typography color='primary' sx={{fontSize: '.9rem', textAlign: 'right'}}>Processing Fee:</Typography>
                                </Grid>
                                <Grid item xs={6} style={{padding: '0'}}>
                                    <Typography color='textPrimary' sx={{fontSize: '.9rem', textAlign: 'right', paddingRight: '2rem'}}>
                                        {getCurrency(paymentRequest.feeAmount)}
                                    </Typography>
                                </Grid>
                                <Grid item xs={6} style={{padding: '0'}}>
                                    <Typography color='primary' sx={{fontSize: '.9rem', textAlign: 'right'}}>Payment Total:</Typography>
                                </Grid>
                                <Grid item xs={6} style={{padding: '0'}}>
                                    <Typography color='textPrimary' sx={{fontSize: '.9rem', textAlign: 'right', paddingRight: '2rem'}}>
                                        {getCurrency(paymentRequest.totalAmount)}
                                    </Typography>
                                </Grid>
                            </Grid>:
                            <>
                                <Typography component='span' variant='subtitle1' color='primary' sx={{fontSize: '1.2rem'}}>
                                    Amount:
                                </Typography>
                                <Typography component='span' variant='subtitle2' color='textPrimary' sx={{fontSize: '1.2rem', marginLeft: '1rem'}}>
                                    {getCurrency(paymentRequest.totalAmount)}
                                </Typography>
                            </>
                        }
                    </Grid>
                    <Grid item xs={12} sm={6} >
                        <FormControl fullWidth sx={{marginLeft: smallScreen ? '0' : '.5rem'}}>
                            <FormLabel htmlFor='name' shrink={true} required sx={{...classes.inputLabel, paddingTop: '0', marginTop: '0'}}>
                                Name on Account
                            </FormLabel>
                            <TextField
                                id='name'
                                name='name'
                                variant='outlined'
                                fullWidth
                                defaultValue={paymentRequest.payorName}
                                value={name}
                                onChange={(e) => {
                                    setName(e.target.value);
                                    handleName(e);
                                }}
                                inputProps={{sx: classes.textbox, "aria-required": "true"}}
                                aria-invalid={hasValidationErrors()}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6} sx={{paddingLeft: '0'}}>
                        <FormControl fullWidth sx={{marginLeft: '0'}}>
                            <FormLabel htmlFor='routingNumber' shrink={true} required sx={classes.inputLabel}>
                                Routing Number</FormLabel>
                            <PatternFormat
                                id='routingNumber'
                                name='routingNumber'
                                customInput={TextField}
                                type='text'
                                autoComplete='off'
                                variant='outlined'
                                format='#########'
                                InputProps={{
                                    sx: classes.numberbox,
                                    inputProps: {"aria-required": "true"}
                                }}
                                onValueChange={(values) => handleRoutingNumber(values)}
                                aria-invalid={hasValidationErrors()}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6} sx={{paddingLeft: '0'}}>
                        <FormControl fullWidth sx={{marginLeft: smallScreen ? '0' : '.5rem'}}>
                            <FormLabel htmlFor='accountNumber' shrink={true} required sx={classes.inputLabel}>Bank Account Number</FormLabel>
                            <TextField
                                id='accountNumber'
                                name='accountNumber'
                                variant='outlined'
                                fullWidth
                                onBlur={handleAccountNumber}
                                inputProps={{sx: classes.textbox, "aria-required": "true"}}
                                aria-invalid={hasValidationErrors()}
                            />
                        </FormControl>
                    </Grid>
                    { court?.requireAddress &&
                        <>
                            <Grid item xs={12} sm={6} sx={{paddingLeft: '0'}}>
                                <FormControl fullWidth >
                                    <FormLabel htmlFor='address' required={!!court?.requireAddress} sx={classes.inputLabel}>Billing Address</FormLabel>
                                    <TextField
                                        id='address'
                                        name='address'
                                        variant='outlined'
                                        fullWidth
                                        defaultValue={paymentRequest.payorAddress}
                                        onChange={(e) => paymentRequest.payorAddress = e.target.value}
                                        inputProps={{
                                            sx: classes.textbox,
                                            "aria-required": !!court?.requireAddress ? "true" : "false"
                                        }}
                                        aria-invalid="false"
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} sx={{paddingLeft: smallScreen ? '0' : '.5rem'}}>
                                <FormControl fullWidth sx={{marginLeft: smallScreen ? '0' : '.5rem'}}>
                                    <FormLabel htmlFor='city' required={!!court?.requireAddress} sx={classes.inputLabel}>Billing City</FormLabel>
                                    <TextField
                                        id='city'
                                        name='city'
                                        variant='outlined'
                                        fullWidth
                                        defaultValue={paymentRequest?.payorCity}
                                        onChange={(e) => paymentRequest.payorCity = e.target.value}
                                        inputProps={{
                                            sx: classes.textbox,
                                            "aria-required": "true"
                                        }}
                                        aria-invalid="false"
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} sx={{paddingLeft: '0'}}>
                                <FormControl fullWidth>
                                    <FormLabel htmlFor='state' required={!!court?.requireAddress} sx={classes.inputLabel}>Billing State</FormLabel>
                                    <Select
                                        id='state'
                                        name='state'
                                        native
                                        variant='outlined'
                                        fullWidth
                                        defaultValue={paymentRequest?.payorState}
                                        onChange={(e) => paymentRequest.payorState = e.target.value}
                                        sx={{height: '2rem'}}
                                        inputProps={{
                                            id: 'optionSelect',
                                            "aria-required": "true"
                                        }}
                                        aria-invalid="false"
                                    >
                                        <option key='None' value=''>Select your state</option>
                                        {statesLong.map((state) => (
                                            <option key={state.key} value={state.value} style={{fontSize: '.9rem'}}>{state.text}</option>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} sx={{paddingLeft: smallScreen ? '0' : '.5rem'}}>
                                <FormControl fullWidth sx={{marginLeft: smallScreen ? '0' : '.5rem'}}>
                                    <FormLabel htmlFor='billingZip' shrink={true} required={!!court.requireZip} sx={classes.inputLabel}>Billing Zip</FormLabel>
                                    <PatternFormat
                                        id='billingZip'
                                        name='billingZip'
                                        customInput={TextField}
                                        type='text'
                                        autoComplete='off'
                                        variant='outlined'
                                        format='#####'
                                        InputProps={{
                                            sx: classes.numberbox,
                                            inputProps: {
                                                "aria-required": !!court.requireZip ? "true" : "false"
                                            }
                                        }}
                                        defaultValue={paymentRequest.billingZip}
                                        onValueChange={(values) => handleZip(values)}
                                        aria-invalid={hasValidationErrors()}
                                    />
                                </FormControl>
                            </Grid>
                        </>
                    }
                    <Grid item xs={12} sm={6} sx={{paddingLeft: '0'}}>
                        <FormControl fullWidth>
                            <FormLabel htmlFor='email' shrink={true} sx={classes.inputLabel}>Email Address</FormLabel>
                            <TextField
                                id='email'
                                name='email'
                                variant='outlined'
                                fullWidth
                                defaultValue={paymentRequest.email}
                                onBlur={handleEmail}
                                inputProps={{sx: classes.textbox}}
                                aria-invalid={hasValidationErrors()}
                                autoComplete='email'
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6} sx={{paddingLeft: '0'}}>
                        <FormControl fullWidth sx={{marginLeft: smallScreen ? '0' : '.5rem'}}>
                            <FormLabel htmlFor='phone' shrink={true} sx={classes.inputLabel}>Phone Number</FormLabel>
                            <PatternFormat
                                id='phone'
                                name='phone'
                                customInput={TextField}
                                type='text'
                                autoComplete='off'
                                variant='outlined'
                                format="(###) ###-####"
                                InputProps={{sx: classes.numberbox}}
                                defaultValue={paymentRequest.phone}
                                onValueChange={(values) => handlePhone(values)}
                                aria-invalid={hasValidationErrors()}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sx={{paddingLeft: '0'}}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    name="tandc"
                                    color='primary'
                                    defaultChecked={false}
                                    onChange={(e) => {setAcceptTerms(e.target.checked)}}
                                />
                            }
                            label={ smallScreen ?
                                <Typography component="span" sx={{fontSize: '.9rem'}}>
                                    I accept the <Link onClick={() => {setOpenTandC(true)}} onKeyDown={handleKeyDown} href="#">Payment Terms</Link>
                                </Typography> :
                                <Typography component="span" sx={{fontSize: '1.2rem'}}>
                                    I agree to the <Link onClick={() => {setOpenTandC(true)}} onKeyDown={handleKeyDown} href="#">CitePayUSA Terms and Conditions</Link>
                                </Typography>
                            }
                            sx={{...classes.checkbox, marginTop: '1rem', marginLeft: '-2rem', paddingLeft: '0', lineHeight: smallScreen ? '.85rem' : ''}}
                        />
                    </Grid>
                </Grid>
            </Paper>
        </>
    );
}

export default CheckData;
